import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import axios from "axios";
import WTinyMce from "@/components/wrappers/w-tiny-mce.vue";
import { Component, Prop, Vue } from "vue-facing-decorator";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
import { Events } from "@/events/events";
let ChapterPageEditor = class ChapterPageEditor extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "chapterId", void 0);
    _defineProperty(this, "pageContent", null);
    _defineProperty(this, "editorConfig", null);
  }
  mounted() {
    window?.tinymce?.get(this.editorId)?.destroy();
    this.getPageEditorContentAndBuildEditorConfig();
  }
  get editorId() {
    return `chapter-page-editor-${this.chapterId}`;
  }
  get editorContent() {
    return this.pageContent?.htmlContent || '';
  }
  getPageEditorContentAndBuildEditorConfig() {
    axios.get(`/api/v2/chapter/${this.chapterId}/html-content-for-editing`).then(({
      data
    }) => {
      this.pageContent = data;
      this.editorConfig = this.buildEditorConfig();
    }).catch(() => WElMessage.showErrorMessage(this.$t('errors.default')));
  }
  buildEditorConfig() {
    return {
      plugins: 'lists advlist code preview link media code codesample table accordion',
      toolbar: `undo redo | bold italic underline strikethrough hr | fontfamily blocks forecolor backcolor removeformat | bullist numlist outdent indent align |
                  customimageupload media table | customchecklist accordion flipcard | custombutton link codesample lgit ink | code`,
      media_live_embeds: true,
      height: '100%'
    };
  }
  savePageContent(newPageContent) {
    if (newPageContent !== this.pageContent?.htmlContent) {
      const data = {
        chapterId: this.chapterId,
        htmlContent: newPageContent
      };
      if (this.pageContent?.id) {
        data.id = this.pageContent.id;
      }
      this.putData(data);
    }
  }
  putData(data) {
    axios.put(`/api/v2/chapter/${this.chapterId}/html-content`, {
      pageContentJson: JSON.stringify(data)
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(() => {
      this.pageContent = data;
      WElMessage.showSuccessMessage(this.$t('chapter.pageEditor.onSaveSuccess'));
      trig(Events.RAFRAICHIR_PLAN_CHAPITRE, this.chapterId);
    }).catch(() => {
      WElMessage.showErrorMessage(this.$t('errors.default'));
    });
  }
  handleEditorBlurEvent(htmlContent) {
    this.savePageContent(htmlContent);
  }
};
__decorate([Prop({
  required: true
})], ChapterPageEditor.prototype, "chapterId", void 0);
ChapterPageEditor = __decorate([Component({
  components: {
    WTinyMce
  }
})], ChapterPageEditor);
export default ChapterPageEditor;